import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  response: null,
  user: "",
  roles: [],
  permissions: [],
  products: [],
  isAdmin: false,
  entity_id: 0,
  error: "", // for error msg
  loading: false,
  isUserLogout: false,
  errorMsg: false, // for error
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    loginSuccess(state, action) {
      state.user = action.payload;
      state.loading = false;
      state.errorMsg = false;
    },
    rolesPermissions(state, action) {
      // console.log(action.payload);
      // console.log(action.payload.userInfo.name);
      state.entity_id = action.payload.userInfo.entity_id;
      state.user = action.payload.userInfo.name;
      state.isAdmin = action.payload.isAdmin ?? false;
      state.roles = action.payload.roles;
      state.permissions = action.payload.permissions;
      state.products = action.payload.products;
    },
    apiError(state, action) {
      state.error = action.payload;
      state.loading = true;
      state.isUserLogout = false;
      state.errorMsg = true;
    },
    resetLoginFlag(state) {
      // state.error = null;
      state.error = "";
      state.loading = false;
      state.errorMsg = false;
    },
    logoutUserSuccess(state, action) {
      state.isUserLogout = true;
    },
  },
});
export const {
  loginSuccess,
  apiError,
  rolesPermissions,
  resetLoginFlag,
  logoutUserSuccess,
} = loginSlice.actions;
export default loginSlice.reducer;
